<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData"   :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detailtemplatmanager',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edittemplatmanager',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
                <a class="tableLink"  href="javascript:;" @click="handleStatus(record)">查询结果</a>

            </template>
            <template slot="needoemNames" slot-scope="text">
                <span >{{ needoemNames[text] }}</span>
            </template>

            <template slot="applystatusNames" slot-scope="text">
                <span >{{ applystatusNames[text] }}</span>
            </template>

            <template slot="templatetype" slot-scope="text">
                <span >{{ templatetype[text] }}</span>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const needoemNames = {
    '1':'是',
    '0':'否',
}

const applystatusNames = {
    '0':'审核中',
    '1':'审核通过',
    '2':'审核失败',
    '3':'待提交审核'
}

const templatetype = {
    '1':'验证码',
    '2':'通知短信',
    '3':'推广短信',
}

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    
    {
        title: "模板编码",
        dataIndex: "templatecode",
        align: "center",
        scopedSlots: { customRender: 'domainNames' },
        width:120
    },
    {
        title: "模板名称",
        dataIndex: "templatename",
        align: "center",
        ellipsis: true,
        width:120
    },

    {
        title: "申请状态",
        dataIndex: "applystatus",
        scopedSlots:{ customRender:'applystatusNames' },
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "申请平台",
        dataIndex: "applyorigin",
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "oem类",
        dataIndex: "needoem",
        align: "center",
        scopedSlots:{ customRender:'needoemNames' },
        width:100,
        ellipsis: true,
    },
    {
        title: "模板类型",
        dataIndex: "templatetype",
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "备注",
        dataIndex: "remark",
        align: "center",
        width:120,
        ellipsis: true,
    },
    {
        title: "申请时间",
        dataIndex: "applytime",
        align: "center",
        width:180,
        ellipsis: true,
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        align: "center",
        width:180,
        ellipsis: true,
    },


    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            needoemNames,
            templatetype,
            applystatusNames,

        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "wxtemplatemanager/deleteSmsTemoplateApply",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        handleStatus(item){
            let that = this;
            that.$store.dispatch({
                type: "wxtemplatemanager/querySmsTemplateApplyStatus",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    this.getAppSumData()
                }
            });
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "wxtemplatemanager/querySmsTemplateApplyPageList",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

